// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "dispatch-map" + "." + "b6f9854d" + ".chunk.css";
};